import { render, staticRenderFns } from "./loginBInd.vue?vue&type=template&id=75c1274e&scoped=true&"
import script from "./loginBInd.vue?vue&type=script&lang=js&"
export * from "./loginBInd.vue?vue&type=script&lang=js&"
import style0 from "./loginBInd.vue?vue&type=style&index=0&id=75c1274e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c1274e",
  null
  
)

export default component.exports